import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultConversionAddInfo } from '../interfaces/ConversionIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface CB02ConversionAddProps {
  execConversionAdd: (
    deviceId: string,
    pre_conversion_text: string,
    post_conversion_text: string,
  ) => Promise<ResultConversionAddInfo>
  loading: loadStatus
}
// CB02 強制単語登録API呼出
export const useCB02ConversionAdd = (): CB02ConversionAddProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execConversionAdd = async (
    deviceId: string,
    pre_conversion_text: string,
    post_conversion_text: string,
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      // ボディ作成
      const body = {
        pre_text: pre_conversion_text,
        post_text: post_conversion_text,
        language: 'ja',
      }

      const response = await axios.post(
        buildDeviceUrl(deviceId, apiUrl.conversionsPath),
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execConversionAdd, loading }
}
